export const initLogos = () => {
	const logos = document.querySelectorAll('.logos__item')

	if (!logos.length) return

	function changeLogo(index) {
		logos.forEach(logo => logo.classList.remove('active'))
		logos[index].classList.add('active')
	}

	let currentIndex = 0

	setInterval(() => {
		changeLogo(currentIndex)
		currentIndex++
		if (currentIndex >= logos.length) {
			currentIndex = 0
		}
	}, 2000)

	changeLogo(0)
}

export default () => {}